import { resGetUploadConfig } from '@/api/index'
const OSS = require('ali-oss');


export function ossInit(config){
  let region = config.endpoint.replace('.aliyuncs.com', '')
  const client = new OSS({
    // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
    region,
    // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
    accessKeyId: config.accessKeyId,
    accessKeySecret: config.accessKeySecret,
    // 从STS服务获取的安全令牌（SecurityToken）。
    stsToken: config.security_token,
    refreshSTSToken: async () => {
    // 向您搭建的STS服务获取临时访问凭证。
      const info = await resGetUploadConfig();
      return {
        accessKeyId: info.accessKeyId,
        accessKeySecret: info.accessKeySecret,
        stsToken: info.security_token
      }
    },
    // 刷新临时访问凭证的时间间隔，单位为毫秒。
    refreshSTSTokenInterval: 300000,
    // 填写Bucket名称。
    bucket: config.bucket
  });
  return client
}


export function randomString(length) {
  var str = '01234dasasadieowwh28a0022156789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var result = '';
  for (var i = length; i > 0; --i) 
      result += str[Math.floor(Math.random() * str.length)];
  return result;
}
const formatNumber = (n) => {
  n = n.toString()
  return n[1] ? n : `0${n}`
}
export function getDay() {
  var date = new Date()
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  return `${[year, month, day].map(formatNumber).join('')}`
}

export function getThumbUrl (url, width){
  if(!url)return '';
  width = parseInt(width)
  if(url.indexOf('?')>=0)return url + '&x-oss-process=image/resize,m_fill,w_' + width
  return url + '?x-oss-process=image/resize,m_fill,w_' + width
}
